import { render, staticRenderFns } from "./CoursedogLink.vue?vue&type=template&id=e2e34d88&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports